require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-target-market-worksheet.json") })
        }
      }, "path---tapd-in-target-market-worksheet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-target-market-worksheet!./.cache/json/tapd-in-target-market-worksheet.json
// module id = 867
// module chunks = 231608221292675